import { render } from "./PannGestInterventiInCorso.vue?vue&type=template&id=dbf56186"
import script from "./PannGestInterventiInCorso.vue?vue&type=script&lang=js"
export * from "./PannGestInterventiInCorso.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\CONAD_MANUTENZIONI\\conad-manutenzioni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__